var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var Plus = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 1.42101C13 0.868726 12.5523 0.421011 12 0.421011C11.4478 0.421011 11 0.868726 11 1.42101L11 11.0022L1.41886 11.0022C0.866573 11.0022 0.418858 11.4499 0.418857 12.0022C0.418857 12.5545 0.866573 13.0022 1.41886 13.0022L11 13.0022V22.5833C11 23.1356 11.4478 23.5833 12 23.5833C12.5523 23.5833 13 23.1356 13 22.5833V13.0022L22.5812 13.0022C23.1335 13.0022 23.5812 12.5545 23.5812 12.0022C23.5812 11.4499 23.1335 11.0022 22.5812 11.0022L13 11.0022L13 1.42101Z", fill: "currentColor" }) })));
};
